import useMyUser from "src/api/hooks/useMyUser";
import useProjectVariations from "src/api/hooks/useProjectVariations";
import { useMapFiles } from "./Features/GeoJSONFiles";
import { useParams } from "react-router-dom";
import { featureColor } from "./featureColor";
import { lang } from "src/language/Strings";
import { mapSettings } from "./mapSettings";
import { useEffect, useState } from "react";
import { useStore } from "src/components/Store";

export function LegendContainer() {
  const { inspectionId, deviationId, companyId } = useParams();
  const { data: deviations } = useProjectVariations();
  const { data: mapFiles } = useMapFiles();
  const { data: myUser } = useMyUser();
  const [collapsed, setCollapsed] = useState(true);
  const store = useStore();
  const commonClassNames ="flex flex-row items-center border-b border-Grey2 p-2 transition-all ease-in-out duration-300 ";
  useEffect(() => {
    if (!store.displayedMapLayers.length) {
      store.setDisplayedMapLayers(mapFiles?.map((file) => file?.depiction) ?? []);
    }
  },[mapFiles?.length])
  
    if (!(inspectionId || deviationId) && mapFiles?.length && mapFiles?.length > 0 ){
      if (collapsed) {
        return (
          <div id="legend-container" onClick={() => setCollapsed(false)} className="font-bold text-lg flex flex-col gap-2 justify-end items-left top-parent absolute right-0 bg-White bg-opacity-80 p-2 rounded-lg z-20 max-h-full w-full overflow-y-auto shadow-lg">
            <button className="flex flex-row items-center" ><span className="w-6 h-6 rounded-full"></span><span id="inspection-legend" className={`flex items-center transition-all duration-300 gap-2 ml-2`}>{lang.showLayers}</span></button>
          </div>
        )
      }
      else {
      return (
            <div id="legend-container" className="flex flex-col gap-2 justify-end items-left top-parent absolute right-0 bg-White bg-opacity-80 rounded-lg z-20 max-h-[79.2vh] w-full shadow-lg transition-all duration-300">
              <div className="flex flex-col gap-2 overflow-y-auto overflow-x-hidden p-2" style={{ maxHeight: 'calc(79.2vh - 1rem)' }}>
                {/* { deviations && deviations.length > 0 && <div className={commonClassNames}><span className="w-6 h-6 rounded-full" style={{ backgroundColor: featureColor.Inspection }}></span><span id="inspection-legend" className={`flex items-center transition-all duration-300 gap-2 ml-2`}>{companyId !== "10" ? "Tillsyn" : lang.inspection}</span></div>} */}
                {mapFiles?.length > 0 && mapFiles.map((file, index) => (
                  <div className={commonClassNames} key={`map-file-legend-${index}`} onClick={() => {
                    if (store.displayedMapLayers.includes(file?.depiction)) {
                      store.setDisplayedMapLayers(store.displayedMapLayers.filter((layer) => layer !== file?.depiction));
                    }
                    else {
                      store.setDisplayedMapLayers([...store.displayedMapLayers, file?.depiction]);
                    }
                  }}><span  className="w-6 h-6 rounded-full transition-all ease-in-out" style={{ backgroundColor: store.displayedMapLayers.includes(file?.depiction) ? (file as any)?.data?.features?.[0]?.properties?.markerColor : "#ddd" }}></span><span id={`map-file-legend-${index}`} className={`flex items-center transition-all ease-in-out gap-2 ml-2 ${store.displayedMapLayers.includes(file?.depiction) ? "text-Grey9 font-bold" : "text-Grey7"}`}>{file?.depiction}</span></div>
                ))}
                <div className={commonClassNames}><span className="w-6 h-6 rounded-full transition-all ease-in-out" style={{ backgroundColor: mapSettings.userLocationColor }}></span><span id="user-position-legend" className={`flex items-center transition-all ease-in-out gap-2 ml-2`}>{lang.userPosition}</span></div>
              </div>
              <div className="p-2 border-t border-Grey2">
                <button className={commonClassNames} onClick={() => setCollapsed(true)}><span className="w-6 h-6 rounded-full transition-all ease-in-out"></span><span id="inspection-legend" className={`flex items-center transition-all ease-in-out gap-2 ml-2`}>{lang.hideLayers}</span></button>
              </div>
            </div>
    )
  }
  }
  else {
    return null;
  }
}